import i18n from '@yandex-int/i18n';

import * as keyset from './i18n';

export const i18nSuggest = i18n(keyset);
